module.exports = __webpack_public_path__ + "static/img/ic_check_red_on@2x.90d8d85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_check_red_on@2x.png
// module id = WdEo
// module chunks = 1